module.exports = __webpack_public_path__ + "media/assets/images/flags/be-ac346245d2ff13ee421722bef6c9d4cb.svg";